import React, { useState, useEffect } from 'react';

export const CookieConsent = ({ language, onAccept, onDecline }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = sessionStorage.getItem('viaturkey_cookie_consent');
      if (!consent) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const texts = {
    en: {
      title: 'Cookie & Privacy Notice',
      message: 'We use cookies and analytics to improve your experience on our website. By accepting, you allow us to collect anonymous usage data such as pages visited and interactions. Your personal data will not be shared with third parties.',
      accept: 'Accept Cookies',
      decline: 'Decline'
    },
    ru: {
      title: 'Уведомление о файлах cookie',
      message: 'Мы используем файлы cookie и аналитику для улучшения вашего опыта на нашем сайте. Принимая, вы разрешаете нам собирать анонимные данные об использовании. Ваши персональные данные не будут переданы третьим лицам.',
      accept: 'Принять',
      decline: 'Отклонить'
    },
    ar: {
      title: 'إشعار ملفات تعريف الارتباط والخصوصية',
      message: 'نستخدم ملفات تعريف الارتباط والتحليلات لتحسين تجربتك على موقعنا. بقبولك، تسمح لنا بجمع بيانات استخدام مجهولة. لن تتم مشاركة بياناتك الشخصية مع أطراف ثالثة.',
      accept: 'قبول',
      decline: 'رفض'
    },
    tr: {
      title: 'Cerez ve Gizlilik Bildirimi',
      message: 'Web sitemizde deneyiminizi iyilestirmek icin cerezler ve analitik kullaniyoruz. Kabul ederek, anonim kullanim verilerini toplamamiza izin verirsiniz. Kisisel verileriniz ucuncu taraflarla paylasilmayacaktir.',
      accept: 'Kabul Et',
      decline: 'Reddet'
    }
  };

  const t = texts[language] || texts.en;

  const handleAccept = () => {
    try { sessionStorage.setItem('viaturkey_cookie_consent', 'accepted'); } catch {}
    try { window.viaturkeyLoadAnalytics && window.viaturkeyLoadAnalytics(); } catch {}
    setVisible(false);
    onAccept();
  };

  const handleDecline = () => {
    try { sessionStorage.setItem('viaturkey_cookie_consent', 'declined'); } catch {}
    setVisible(false);
    onDecline();
  };

  if (!visible) return null;

  return (
    <div className="cookie-overlay" data-testid="cookie-consent-modal">
      <div className="cookie-modal">
        <div className="cookie-icon">&#128274;</div>
        <h3 className="cookie-title">{t.title}</h3>
        <p className="cookie-message">{t.message}</p>
        <div className="cookie-actions">
          <button className="cookie-accept-btn" onClick={handleAccept} data-testid="cookie-accept-btn">{t.accept}</button>
          <button className="cookie-decline-btn" onClick={handleDecline} data-testid="cookie-decline-btn">{t.decline}</button>
        </div>
      </div>
    </div>
  );
};
